export default "__VITE_ASSET__DgaZCq7___"